import { TileBase } from "./TileBase";
import { MapCell as PredefinedMapCell, eTileType } from "../Game Map/MapCell";
import { Game, eModelAsset } from "../../../Game";
import { ViewCellMapCell } from "../View/ViewCellMapCell";



export class SolidTile extends TileBase {
    private static VERSION_ASSET: pc.Asset[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super(eTileType.solid);
        this._version = -1;

        // Assety pro jednotlive verze dlazdice
        if (!SolidTile.VERSION_ASSET) {
            SolidTile.VERSION_ASSET = [
                Game.app.assets.find(eModelAsset.tileSolid_0, pc.ASSET_MODEL),
                Game.app.assets.find(eModelAsset.tileSolid_1, pc.ASSET_MODEL),
                Game.app.assets.find(eModelAsset.tileSolid_2, pc.ASSET_MODEL),
            ];
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(cell: ViewCellMapCell, cellData: PredefinedMapCell): void {
        if (this._version != cellData.tileVersion)
            // Nastavit model     
            this._entity.model.asset = SolidTile.VERSION_ASSET[cellData.tileVersion];

        super.init(cell, cellData);
    }
}